import { render } from "./course-center.vue?vue&type=template&id=6a961082"
import script from "./course-center.vue?vue&type=script&lang=js"
export * from "./course-center.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__